import React, { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../common/types';
import { editorMessages } from '../editorMessages';
import { BlockDescription } from './describeBlock';
import { SMLBlockThumb } from './SMLBlockThumb';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './SMLBlockSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLBlockSheetProps {
  widget: SerializedWidget;
  description: BlockDescription | null;
  onClose: () => void;
}

/** Below 992 px the form of a row opens as a sheet (design a8). `?block=<uuid>`; Back closes it. */
const SMLBlockSheetComponent: React.FC<PropsWithChildren<SMLBlockSheetProps>> = ({
  widget,
  description,
  onClose,
  children,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.overlay} data-testid="block-sheet">
      <button
        type="button"
        className={styles.scrim}
        onClick={onClose}
        aria-label={intl.formatMessage(editorMessages.close)}
      />
      <div className={styles.sheet} role="dialog" aria-modal="true" aria-label={description?.name}>
        <span className={styles.grab} />
        <div className={styles.head}>
          <SMLBlockThumb widget={widget} isWarn={description?.tone === 'warn'} />
          <span className={styles.name}>
            {description?.name}
            {description?.typeLabel !== null && description?.typeLabel !== undefined && (
              <span className={styles.type}>{description.typeLabel}</span>
            )}
          </span>
          <button
            type="button"
            className={styles.close}
            onClick={onClose}
            aria-label={intl.formatMessage(editorMessages.close)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
};

export const SMLBlockSheet = TypedMemo(SMLBlockSheetComponent);
